import React from "react"
import Select from "react-select"

class SelectField extends React.Component {
  render() {
    const {
      options, placeholder,
      input: { value, onChange },
    } = this.props

    const colourStyles = {
      control: styles => ({
        ...styles,
        minHeight: "38px",
        borderRadius: "2px ",
        border: "1px solid #707070",
        backgroundColor: "#FFFFFF",
      }),
      valueContainer : styles => ({...styles, marginLeft: "10px"})
    }

    return (
      <Select
        value={value}
        isMulti
        placeholder={placeholder}
        onChange={onChange}
        styles={colourStyles}
        options={options.map(option => ({
          value: option.id,
          label: option.name,
        }))}
      />
    )
  }
}

export default SelectField



// WEBPACK FOOTER //
// src/components/SelectField/index.jsx